import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import ElementPlaceholder from "~/components/ElementPlaceholder/ElementPlaceholder";
import * as Items from "./columns";
import PreviewTaskItemColumns from "../MyWork/MyTasks/PreviewTaskItemColumns";

export const TaskItemColumn = React.memo(({ type, value, isForMyWork, inView, ...rest }) => {
  const { taskId } = rest;
  if (!value || !Items[type]) {
    return null;
  }

  if (!inView) {
    return !isForMyWork ? (
      <ElementPlaceholder
        className={classNames("tw-hidden lg:tw-flex col tw-h-8 tw-m-1 tw-rounded", `col-${type.toLowerCase()}`)}
      />
    ) : (
      <PreviewTaskItemColumns
        taskId={taskId}
        type={type}
      />
    );
  }
  const Item = Items[type];
  return (
    <div className={classNames("tw-hidden lg:tw-flex tw-justify-end col", `col-${type.toLowerCase()}`)}>
      <Item {...rest} />
    </div>
  );
});

TaskItemColumn.displayName = "TaskItemColumn";

TaskItemColumn.propTypes = {
  type: PropTypes.string.isRequired,
  name: PropTypes.string,
  value: PropTypes.bool,
  taskId: PropTypes.number,
  projectId: PropTypes.number.isRequired,
  inView: PropTypes.bool,
  isForMyWork: PropTypes.bool,
};
